module.exports = __webpack_public_path__ + "static/media/Uc1.1b6aac39.png";